"use strict";

function setRegisterReturnPath() {
  localStorage.setItem('registerReturnPath', window.location.pathname);
}
document.addEventListener('DOMContentLoaded', async () => {
  const returnPath = localStorage.getItem('registerReturnPath');
  const returnMessage = JSON.parse(localStorage.getItem('registerReturnMessage'));
  if (window.location.pathname.includes('/accounts/registration/confirm-email')) {
    const urlParts = window.location.pathname.split('/');
    const confirmationKey = urlParts.slice(-2, -1).pop();
    const verifyEmailUrl = `${window.baseApiUrl}/accounts/registration/verify-email`;
    const response = await fetch(verifyEmailUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        key: confirmationKey
      })
    });
    if (response.ok) {
      const responseData = await response.json();
      triggerLogin(responseData.token);
      subscribeToInitialTopics();
      localStorage.setItem('registerReturnMessage', JSON.stringify({
        message: 'Aktivacija je uspješna! Dobrodošli na 24sata!',
        type: 'success'
      }));
      if (returnPath) window.location.href = returnPath;else window.location.href = '/';
    } else {
      const responseData = await response.json();
      localStorage.setItem('registerReturnMessage', JSON.stringify({
        message: responseData.detail,
        type: 'error'
      }));
      if (returnPath) window.location.href = returnPath;else window.location.href = '/';
    }
  }
  if (returnMessage) {
    window.showSnackbar(returnMessage.message, returnMessage.type);
    localStorage.removeItem("registerReturnMessage");
    localStorage.removeItem("registerReturnPath");
  }
});